import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import "./styles.scss";
import { GrFormClose } from "react-icons/gr";
import { Alumni } from "../AlumniList";

interface IProps {
  alumni: Alumni;
  alumnis: Alumni[];
  onHide(): void;
  show: boolean;
  loading?: boolean;
  onReject?: (sessionId: string) => void;
}

const AlumniPreview = (props: IProps) => {
  const [index, setIndex] = useState(0);
  const [currentAlmuni, setCurrentAlumni] = useState(props.alumni);

  useEffect(() => {
    if (index !== -1) setCurrentAlumni(props.alumnis[index]);
  }, [index, props.alumnis]);

  useEffect(() => {
    setCurrentAlumni(props.alumni);
  }, [props.alumni]);

  useEffect(() => {
    const ind: number = props.alumnis.findIndex(
      (session) => session.id === props.alumni.id
    );
    setIndex(ind); //Dont remove the following comment.
  }, [props.show]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="xl"
        className="model-preview-sessions"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {currentAlmuni && (
          <Modal.Body className="content-wrapper">
            <Container style={{ height: "80%" }}>
              <Row className="h-100">
                <Col xs={1} className="h-100 p-0">
                  <Container fluid className="h-100">
                    <Row className="h-100">
                      <Col xs={12} className="p-0" style={{ height: "45%" }}>
                        {/* <GrFormClose
                        className="btn-close"
                        onClick={props.onHide}
                      /> */}
                      </Col>
                      <Col xs={12} className="p-0" style={{ height: "55%" }}>
                        {index > 0 && (
                          <div className="action-icon">
                            <MdNavigateBefore
                              onClick={() => {
                                if (index > 0) {
                                  setIndex((ps) => ps - 1);
                                }
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
                <Col xs={10} className="p-0 h-100">
                  <Container className="h-100">
                    <Row className="pt-3">
                      <Col xs={12} className="content small-scroll">
                        <Container fluid>
                          <Row>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Company name:</strong>{" "}
                                {currentAlmuni.companyName}
                              </p>
                            </Col>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Country:</strong>{" "}
                                {currentAlmuni.country}
                              </p>
                            </Col>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Year:</strong> {currentAlmuni.year}
                              </p>
                            </Col>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Position:</strong>{" "}
                                {currentAlmuni.position}
                              </p>
                            </Col>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Sector:</strong> {currentAlmuni.sector}
                              </p>
                            </Col>

                            {/* <Col xs={12} className="mt-3">
                              <p>
                                <strong>Year:</strong>{" "}
                                <Moment format="MM/DD/YYYY">
                                  {
                                    new Date(
                                      currentAlmuni.createdAt?.seconds * 1000
                                    )
                                  }
                                </Moment>
                              </p>
                            </Col> */}
                          </Row>
                        </Container>
                      </Col>
                    </Row>
                  </Container>
                </Col>

                <Col xs={1} className="h-100 p-0">
                  <Container fluid className="h-100">
                    <Row className="h-100 p-0">
                      <Col
                        xs={12}
                        className="p-0 d-flex justify-content-center"
                        style={{ height: "45%" }}
                      >
                        <GrFormClose
                          className="btn-close"
                          style={{ marginTop: "20px", fontSize: "30px" }}
                          onClick={props.onHide}
                        />
                      </Col>
                      <Col xs={12} className="p-0" style={{ height: "55%" }}>
                        {index < props.alumnis.length - 1 && (
                          <div className="action-icon">
                            <MdNavigateNext
                              onClick={() => {
                                if (index < props.alumnis.length - 1) {
                                  setIndex((ps) => ps + 1);
                                }
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        )}
      </Modal>
    </div>
  );
};

export default AlumniPreview;
